import React from "react";
import {Button} from "antd";
import {useTranslation} from "react-i18next";
import NestedPopoverContent from "../component/nestedPopoverContent";

const PopoverContentConfig = (props) => {
    const {
        platformDownloadKey,
        setPopoverOpen,
        setOpenQrModal,
        platformData,
        popoverContentConfigKey,
        setPopoverContentConfigKey
    } = props;
    const {t} = useTranslation();

    return (
        <div>
            {popoverContentConfigKey && (
                <div className={"popover-nested-header"}>
                    <Button
                        type={"text"}
                        className={"popover-back-button"}
                        onClick={() => {
                            if (platformDownloadKey.some((k) => k[0] === popoverContentConfigKey)) {
                                setPopoverContentConfigKey("download");
                            } else {
                                setPopoverContentConfigKey(null);
                            }
                        }}
                    >
                        &lt;
                    </Button>
                    <div>
                        {popoverContentConfigKey === platformDownloadKey?.[0]?.[0] ? popoverContentConfigKey : t(`common.${popoverContentConfigKey}`)}
                    </div>
                </div>
            )}
            <div className={"popover-select-item-list"}>
                <NestedPopoverContent
                    platformDownloadKey={platformDownloadKey}
                    platformData={platformData}
                    popoverContentConfigKey={popoverContentConfigKey}
                    setPopoverContentConfigKey={setPopoverContentConfigKey}
                    setPopoverOpen={setPopoverOpen}
                    setOpenQrModa={setOpenQrModal}
                />
            </div>
        </div>
    );
};

export default PopoverContentConfig;